import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomCreateAiMappingDetectionMutation } from "generated/graphql";


export const useCreateAiMappingDetection = () => {
  const [mutation, { data, loading, error }] = useCustomCreateAiMappingDetectionMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "createAiMappingDetection" },
    { hideMessage: true }
  );
};
